import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDHeadlineText } from '@facet-wealth/design';

const ScenarioSelectionDetailedSummaryMetaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly);

export default ScenarioSelectionDetailedSummaryMetaOverride;
